import { render, staticRenderFns } from "./remove-modify-item-dialog.vue?vue&type=template&id=14e573c4"
import script from "./remove-modify-item-dialog.vue?vue&type=script&lang=js"
export * from "./remove-modify-item-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuComboActionTile: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-combo-action-tile.vue').default,MenuNormalItemActionTile: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-normal-item-action-tile.vue').default})
